import { FC, ReactElement, useContext } from 'react';
import { Navigate } from 'react-router';

import { AuthContext } from '@providers/Auth';

type ProtectedRouteProps = {
  element: () => ReactElement;
};

const ProtectedRoute: FC<ProtectedRouteProps> = ({ element: Component }) => {
  const { isLoggedIn } = useContext(AuthContext);

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  return <Component />;
};

export default ProtectedRoute;
